import { IconButton, Typography } from "@mui/material";

import { initializeEncryption } from "../../services/AesGcmEncryption";
import * as CONSTANT from "../../constants/Constant";

import { Box, useTheme } from "@mui/material";
import Stack from "@mui/material/Stack";
import { tokens } from "../../theme";
import SectionHeader from "../../components/SectionHeader";
import CustomButton from "../../components/CustomButton";
import Grid from "@mui/material/Unstable_Grid2";
import HighlightStats from "../../components/HighlightStats";
import * as React from "react";
import { DataGrid } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import ConnectionStatus from "../../utils/ConnectionStatus";
import { SnackbarProvider, useSnackbar } from "notistack";
import UseOnlineStatus from "../../utils/UseOnlineStatus";
import dayjs, {  } from "dayjs";

import {
  getFromLocalStorage,
  getFromLocalStorageJsonObject,
  saveToLocalStorageJsonObject,
} from "../../utils/localStorageUtils";
import CustomProgressDialog from "../../components/CustomProgressDialog";
import ShowErrorAlertDialog from "../../components/ErrorAlertDialog";
import { useAtom } from "jotai";
import { showErrorAlertDialog } from "../../config/AppConfig";
import {
  ALERT,
  ERROR_WHILE_FETCHING_DATA,
  NO_INTERNET_CONNECTION_FOUND,
  YOU_ARE_OFFLINE,
  YOU_ARE_ONLINE,
  PROCESSING_PLEASE_WAIT,
  ERROR,
  LOADING_REPORT_NAMES_PLEASE_WAIT,
} from "../../constants/Strings";
import DebugLog from "../../utils/DebugLog";
import {
  LOGIN_ID,
  MESSAGE_KEY,
  SESSION_ID,
  USER_NAME,
  SELECTED_ON_HOLD_TRANSACTION_TYPE,
} from "../../constants/LocalStorageKeyValuePairString";
import {
  generateRandomId,
  generateRequestId,
} from "../../utils/RequestIdGenerator";
import { useNavigate, useLocation } from "react-router-dom";
import { onHoldCompanyColumnHeader } from "../../components/ColumnHeader";
import NoDataFound from "../../components/NoDataFound";
import { ApiErrorCode, ApiType } from "../../services/ApiTags";
import { formatPrice } from "../../utils/PriceFormatter";
import { getButtonVisibilityData } from "../../utils/GetButtonVisibilityAsPerLoginResponse";
import { IncentivesActionsConfirmationDialog } from "../../components/IncentivesActionsConfirmationDialog";
import useAxiosHookV2 from "../../hooks/UseAxiosV2";
import useAxiosHookV2FileUpload from "../../hooks/UseAxiosV2FileUpload";
import { DownloadPayoutOnHoldReportNameSelectionDialog } from "../../components/DownloadPayoutOnHoldReportNameSelectionDialog";
import UseAxiosV1Api from "../../hooks/UseAxiosV1Api";

// Filter Configurations to be passed to SearchBarFilter in SectionHeader
const filterProps = [
  {
      keyValue: 'Transaction Type',
      displayName: 'Name',
      paramName: 'type',
      isDateFilter: false,
      isSearchBarDropdown: false,
      searchBarDropdownOptions: [],
  },
  {
      keyValue: 'Report Date',
      displayName: 'Report',
      paramName: 'reportDate',
      isDateFilter: true,
      isSearchBarDropdown: false,
      searchBarDropdownOptions: [],
  },
  {
      keyValue: 'Cut Off Date',
      displayName: 'Cut Off',
      paramName: 'cutoffDate',
      isDateFilter: true,
      isSearchBarDropdown: false,
      searchBarDropdownOptions: [],
  },
  {
    keyValue: 'Payout Date',
    displayName: 'Payout By',
    paramName: 'payoutDate',
    isDateFilter: true,
    isSearchBarDropdown: false,
    searchBarDropdownOptions: [],
  },
];


export function OnHoldDealerBreakdown() {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const navigate = useNavigate();
  const location = useLocation();
  let selectedOnHoldTransactionType = location.state;

  const isNetworkConnectionAvailable = UseOnlineStatus();

  const [getDialogStatus, setErrorDialog] = useAtom(showErrorAlertDialog);
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [title, setTitle] = useState(ALERT);
  const [content, setContent] = useState("");
  const [, setError] = useState("");
  const [getProgressbarText, setProgressbarText] = useState("");

  const [transactionType, setTransactionType] = useState("");
  const [onHoldHeaderSummary, setOnHoldHeaderSummary] = useState([]);
  const [onHoldSummary, setOnHoldSummary] = useState([]);

  const [gridHeight, setGridHeight] = useState(108); // Default height
  const [rowsPerPage, setRowsPerPage] = useState(0); // Used to set the height of the grid

  // pagination
  const [paginationModel, setPaginationModel] = useState({
    pageSize: 15,
    page: 0,
  });
  const [pageSize, setPageSize] = useState(15);
  const [totalNoOfRows, setTotalNoOfRows] = useState(0);
  const [totalNoOfPages, setTotalNoOfPages] = useState(0);

  const [selectedRows, setSelectedRows] = React.useState([]);

  const [requestReleaseButtonVisible, setRequestReleaseButton] =
    useState(false);
  const [downloadButtonVisible, setDownlaodButton] = useState(false);
  const [releaseButtonVisibility, setReleaseButton] = useState(false);
  const [cancelButtonButtonVisibility, setCancelButton] = useState(false);
  const [commentButtonVisibility, setComment] = useState(false);
  const [rejectButtonVisibility, setRejectButton] = useState(false);

  const [dialogOpen, setDialogOpen] = useState(false);
  const [clickedButtonType, setClickedButtonType] = useState("");
  const [dialogTitle, setDialogTitle] = useState("");

  const [companyCode, setCompanyCode] = useState("");
  const [batchNo, setBatchNo] = useState("");
  const [holdType, setHoldType] = useState("");
  const [flowFrom, setFlowFrom] = useState("");

  const [downloadFileDialogOpen, setDownloadFileDialogOpen] = useState(false);

  const { data, apiCallError, showProgressBar, fetchData } = useAxiosHookV2();
  const {
    dataResponseFileUpload,
    apiCallErrorFileUpload,
    showProgressBarFileUpload,
    fetchDataFileUpload,
  } = useAxiosHookV2FileUpload();
  const [actionButtonVisibility, setActionButtonVisibility] = useState(false);

  const { dataV1, errorV1, showProgressBarV1, fetchDataV1 } = UseAxiosV1Api();
  const [reportNameOptions, setReportNameOptions] = useState([]);
  const [reportNamesValue, setReportNamesValue] = useState([]);
  const [downloadType, setDownloadType] = useState("");

  // filter and search
  const [selectedFilter, setSelectedFilter] = useState("");
  const [searchQuery, setSearchQuery] = useState("");

  // sort model
  const [sortModel, setSortModel] = useState([]);

  // sorting handling 
  useEffect(() => {
    checkSelectedOnHoldTransactionType();

    getOnHoldDealer(
      selectedOnHoldTransactionType?.companyCode,
      selectedOnHoldTransactionType?.holdType,
      selectedOnHoldTransactionType?.batchNo,
      selectedOnHoldTransactionType?.commissionType,
      selectedOnHoldTransactionType?.transactionType,
      paginationModel.page,
      paginationModel.pageSize,
      selectedFilter,
      searchQuery
    );
  }, [sortModel]);

  useEffect(() => {
    if (showProgressBarV1) {
      setProgressbarText(LOADING_REPORT_NAMES_PLEASE_WAIT);
      setLoading(true);
    } else {
      setLoading(false);
    }
  }, [showProgressBarV1]);


  useEffect(() => {
    if (errorV1) {
      if (
        errorV1.message !== null && errorV1.message !== undefined &&
        errorV1.message === ApiErrorCode.NETWORK_ERROR
      ) {
        showErrorAlert(ERROR, errorV1.message);
      } else if (errorV1.data.errorCode === ApiErrorCode.SESSION_EXPIRED) {
        alert(errorV1.data.displayErrorMessage);
        navigate(CONSTANT.LOGIN);
      } else {
        const message =
          errorV1.data !== null && errorV1.data.displayErrorMessage !== null
            ? errorV1.data.displayErrorMessage
            : ERROR_WHILE_FETCHING_DATA;
        showErrorAlert(
          ERROR,
          "/reports/getPayoutReportNames Api error: " +
            message +
            " Batch No" +
            batchNo
        );
      }

      //handleClose();
    }
  }, [errorV1]);

  useEffect(() => {
    if (apiCallErrorFileUpload) {
      if (
        apiCallErrorFileUpload.message !== null && apiCallErrorFileUpload.message !== undefined  &&
        apiCallErrorFileUpload.message === ApiErrorCode.NETWORK_ERROR
      ) {
        showErrorAlert(ERROR, apiCallErrorFileUpload.message);
      } else if (
        apiCallErrorFileUpload.data.errorCode === ApiErrorCode.SESSION_EXPIRED
      ) {
        alert(apiCallErrorFileUpload.data.displayErrorMessage);
        navigate(CONSTANT.LOGIN);
      } else {
        const message =
          apiCallErrorFileUpload.data !== null &&
          apiCallErrorFileUpload.data.displayErrorMessage !== null
            ? apiCallErrorFileUpload.data.displayErrorMessage
            : apiCallErrorFileUpload.message;
        showErrorAlert(
          ERROR,
          ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
        );
      }
    }
  }, [apiCallErrorFileUpload]);

  function getReportNamesFromApi(batchNo) {
    try {
      const requestObject = {
        batchNo: batchNo,
      };

      initializeEncryption(
        requestObject,
        getFromLocalStorage(MESSAGE_KEY),
        ApiType.GET_REPORT_NAMES_LIST
      ).then((encryptedContentData) => {
        fetchDataV1(
          process.env.REACT_APP_REPORT_NAMES_API_URL,
          ApiType.GET_REPORT_NAMES_LIST,
          ApiType.POST_METHOD,
          encryptedContentData,
          {},
          (data) => {
            if (data !== null) {
              if (data.result.reportNames.length > 0) {
                setReportNameOptions(
                  data.result.reportNames.map((item) => item.reportName)
                );
                setReportNamesValue(data.result.reportNames);
              } else {
                showErrorAlert(ALERT, CONSTANT.ERROR_IN_LOADING_REPORT_NAMES);
              }
            }
          }
        );
      });
    } catch (error) {
      const message = error.response != null ? error.response : error.message;
      showErrorAlert(
        error.message,
        ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
      );
    }
  }

  const getReportName = (type) => {
    setDownloadType(type);
    getReportNamesFromApi(batchNo);
  };

  useEffect(() => {
    if (reportNameOptions.length > 0) {
      openDownloadOptionsDialog(downloadType);
    }
  }, [reportNameOptions]);

  useEffect(() => {
    updateButtonVisibility();

    checkSelectedOnHoldTransactionType();
    setHoldType(selectedOnHoldTransactionType?.holdType);
    setFlowFrom(selectedOnHoldTransactionType?.flowFrom);

    if (selectedOnHoldTransactionType?.holdType !== "e-Inv Missing") {
      setActionButtonVisibility(true);
    } else {
      setActionButtonVisibility(false);
    }

    setBatchNo(selectedOnHoldTransactionType?.batchNo + "");
    setCompanyCode(selectedOnHoldTransactionType?.companyCode + "");
    setTransactionType(selectedOnHoldTransactionType?.displayName);

   

    getOnHoldDealer(
      selectedOnHoldTransactionType?.companyCode,
      selectedOnHoldTransactionType?.holdType,
      selectedOnHoldTransactionType?.batchNo,
      selectedOnHoldTransactionType?.commissionType,
      selectedOnHoldTransactionType?.transactionType,
      paginationModel.page,
      paginationModel.pageSize,
      selectedFilter,
      searchQuery
    );
  }, []);

  useEffect(() => {
    getDataGridHeight();

    showNoInternetSnackBar();

    navigate(blockNavigation);
  }, [isNetworkConnectionAvailable, enqueueSnackbar, navigate, rowsPerPage]);

  const updateButtonVisibility = () => {
    const actionButtonList = getButtonVisibilityData("Incentive", "On Hold");
    if (actionButtonList) {
      actionButtonList.forEach((items, index) => {
        // HOLD, DOWNLOAD, APPROVE, VIEW, REQUEST APPROVAL
        if (items.buttonName === "DOWNLOAD") {
          setDownlaodButton(true);
        } else if (items.buttonName === "REQUEST RELEASE") {
          setRequestReleaseButton(true);
        } else if (items.buttonName === "RELEASE") {
          setReleaseButton(true);
        } else if (items.buttonName === "CANCEL") {
          setCancelButton(true);
        }else if (items.buttonName === "REJECT") {
          setRejectButton(true);
        }  else if (items.buttonName === "COMMENT") {
          setComment(true);
        }
      });
    }
  };

  useEffect(() => {
    if (showProgressBar) {
      setProgressbarText(PROCESSING_PLEASE_WAIT);
      setLoading(true);
    } else {
      setLoading(false);
    }
  }, [showProgressBar]);

  const openDownloadOptionsDialog = (type) => {
    if (isNetworkConnectionAvailable) {
      //if(selectedRows.length===1){
      let title = "";
      if (type === "Download") {
        title = "Download";
      }
      setClickedButtonType(type);
      setDialogTitle(title);
      setDownloadFileDialogOpen(true);
      // }else{
      //  // showErrorAlert(ALERT,"Please choose only one row!")
      //   alert("Please choose only one row!")
      // }
    } else {
      showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
    }
  };

  const handleFileDownloadSubmit = (fileType, type, startDate, endDate) => {
    // downloadWithholdingReport(fileType, startDate, endDate);
  };

  const handleFileDownloadDialogClose = () => {
    setDownloadFileDialogOpen(false);
  };

  useEffect(() => {
    if (showProgressBarFileUpload) {
      setProgressbarText(PROCESSING_PLEASE_WAIT);
      setLoading(true);
    } else {
      setLoading(false);
    }
  }, [showProgressBarFileUpload]);

  /********  Pagination Methods ***********/
  const handlePageJump = (event) => {
    const newPage = parseInt(event.target.value, 10) - 1;
    setPaginationModel({ pageSize: pageSize, page: newPage });
    checkSelectedOnHoldTransactionType();

    getOnHoldDealer(
      selectedOnHoldTransactionType?.companyCode,
      selectedOnHoldTransactionType?.holdType,
      selectedOnHoldTransactionType?.batchNo,
      selectedOnHoldTransactionType?.commissionType,
      selectedOnHoldTransactionType?.transactionType,
      newPage,
      paginationModel.pageSize,
      selectedFilter,
      searchQuery
    );
  };

  const handlePageChange = (newPage) => {
    setPaginationModel({ pageSize: pageSize, page: newPage });
    checkSelectedOnHoldTransactionType();

    getOnHoldDealer(
      selectedOnHoldTransactionType?.companyCode,
      selectedOnHoldTransactionType?.holdType,
      selectedOnHoldTransactionType?.batchNo,
      selectedOnHoldTransactionType?.commissionType,
      selectedOnHoldTransactionType?.transactionType,
      newPage,
      paginationModel.pageSize,
      selectedFilter,
      searchQuery
    );
  };

  const handlePageSizeChange = (newPageSize) => {
    // keep pageSize in sync with the paginationModel
    setPageSize(newPageSize);
    setPaginationModel({ pageSize: newPageSize, page: 0 });
    checkSelectedOnHoldTransactionType();

    // call api with new page size and start from page 0.
    getOnHoldDealer(
      selectedOnHoldTransactionType?.companyCode,
      selectedOnHoldTransactionType?.holdType,
      selectedOnHoldTransactionType?.batchNo,
      selectedOnHoldTransactionType?.commissionType,
      selectedOnHoldTransactionType?.transactionType,
      0,
      newPageSize,
      selectedFilter,
      searchQuery
    );
  };

  const handleSelectionChange = (newSelection) => {
    setSelectedRows(newSelection);
  };

  const resetSelection = () => {
    setSelectedRows([]);
  };

  // increase - decrease list layout height on available list itmes count
  function getDataGridHeight() {
    // Calculate the total height required for the grid
    const headerHeight = 60; // Height of header row
    const rowHeight = 60; // Height of each data row
    let rowCount = 0;
    if (rowsPerPage <= pageSize) {
      rowCount = rowsPerPage; // Total number of data rows
    } else {
      rowCount = pageSize; // Total number of data rows
    }

    const totalHeight = headerHeight + rowCount * rowHeight;

    // Set the grid height
    setGridHeight(totalHeight);
  }


  function checkSelectedOnHoldTransactionType() {
    // If selectedPayoutCycle is not in the location state (e.g., after a page refresh),
    // try to retrieve it from localStorage
    if (!selectedOnHoldTransactionType) {
      const storedData = getFromLocalStorageJsonObject(
        SELECTED_ON_HOLD_TRANSACTION_TYPE,
        JSON.stringify(selectedOnHoldTransactionType)
      );
      selectedOnHoldTransactionType = storedData
        ? JSON.parse(storedData)
        : null;
    } else {
      // If payoutRowSelected is in the location state, store it in localStorage
      saveToLocalStorageJsonObject(
        SELECTED_ON_HOLD_TRANSACTION_TYPE,
        JSON.stringify(selectedOnHoldTransactionType)
      );
    }
  }

  /******* API Calls *********/
  async function getHeaderSummary(
    holdType,
    receivedBatchNo,
    companyCode,
    receivedTransactionType
  ) {
    try {
      if (isNetworkConnectionAvailable) {
        const requestObject = {
          holdType: holdType,
          batchNo: receivedBatchNo,
          companyCode: companyCode,
        };

        initializeEncryption(
          requestObject,
          getFromLocalStorage(MESSAGE_KEY),
          ApiType.ON_HOLD_DYNAMIC_HEADER_SUMMARY
        ).then((encryptedContentData) => {
          fetchData(
            process.env.REACT_APP_DYNAMIC_HEADER_API_URL,
            ApiType.ON_HOLD_DYNAMIC_HEADER_SUMMARY,
            ApiType.POST_METHOD,
            encryptedContentData,
            {},
            (data) => {
              if (data !== null) {
                setOnHoldHeaderSummary(data.result);
              }
            }
          );
        });
      } else {
        showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
      }
    } catch (error) {
      const message = error.response != null ? error.response : error.message;
      showErrorAlert(
        error.message,
        ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
      );
    }
  }

  const handleDialogOpen = (type) => {
    if (selectedRows.length === 0) {
      showErrorAlert(ALERT, "Please select some rows first!");
    } else {
      let title = "";
      if (type === "Cancel") {
        title = "Cancel";
      }  else if (type === "Reject") {
        title = "Reject";
      }else if (type === "Release") {
        title = "Release";
      } else if (type === "Request Release") {
        title = "Request Release";
      }
      setClickedButtonType(type);
      setDialogTitle(title);
      setDialogOpen(true);
    }
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  const handleSubmit = (file, comment, type, selectedDate) => {
    let formattedDate = selectedDate;
    if (type === "Cancel") {
      formattedDate = null;
    }
    dialogResponseRecieved(file, comment, type, formattedDate);
  };

  const dialogResponseRecieved = (file, comment, type, date) => {
    if (date === null) {
      const today = dayjs(); //2024-07-24
      date = today.format("YYYY-MM-DD");
    }
    const selectedData = onHoldSummary.filter((row) =>
      selectedRows.includes(row.id)
    );

    // if (selectedData.length > 0) {
    const extractBatchNo = selectedData[0].batchNo;
    const extractVersionCode = selectedData[0].version;

    const transactionTypes = selectedData.map((item) => item.transactionType);

    if (file) {
      const fileNameWithoutExtension = file.name
        .split(".")
        .slice(0, -1)
        .join(".");

      handleFileChange(
        file,
        extractBatchNo,
        fileNameWithoutExtension,
        comment,
        extractVersionCode,
        transactionTypes,
        type,
        date
      );
       return;
    } else {
      const requestData = {
        holdType: holdType,
        batchNo: extractBatchNo + "",
        remark: comment,
        companyCode: companyCode,
        transactionTypes: transactionTypes,
        selectedDate: date,
      };

      if (type === "Cancel") {
        requestOnHoldCancel(requestData, "");
      } else if (type === "Release") {
        releaseOnHoldApiRequest(requestData, "");
      } else if (type === "Request Release") {
        requestReleaseOnHoldApiCall(requestData, "");
      }
      else if (type === "Reject") {
        rejectOnHoldApiRequest(requestData, "");
      }
      DebugLog("onHold Request Data =======" + JSON.stringify(requestData));
    }
  };

  const handleFileChange = async (
    selectedFile,
    extractBatchNo,
    fileNameWithoutExtension,
    comment,
    extractVersionCode,
    transactionTypes,
    type,
    date
  ) => {
    try {
      const fileBase64Encoding = await getBase64(selectedFile);
      // Extract only the Base64 data
      const base64Only = fileBase64Encoding.split(",")[1];
      const requestData = {
        holdType: holdType,
        batchNo: extractBatchNo + "",
        fileName: fileNameWithoutExtension,
        fileType: selectedFile.type,
        remark: comment,
        transactionTypes: transactionTypes,
        companyCode: companyCode,
        selectedDate: date,
      };
      DebugLog(
        "onHold Request Data base64 =======" + JSON.stringify(requestData)
      );

      if (type === "Cancel") {
        requestOnHoldCancel(requestData, base64Only);
      } else if (type === "Release") {
        releaseOnHoldApiRequest(requestData, base64Only);
      } else if (type === "Request Release") {
        requestReleaseOnHoldApiCall(requestData, base64Only);
      }else if (type === "Reject") {
        rejectOnHoldApiRequest(requestData, base64Only);
      }

      // return base64String;
    } catch (error) {
      console.error("Error converting file to byte array:", error);
    }
  };

  const getBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };

  const releaseOnHoldApiRequest = (
    onHoldCancelRequestData,
    fileBase64Encoding
  ) => {
    try {
      if (isNetworkConnectionAvailable) {
        initializeEncryption(
          onHoldCancelRequestData,
          getFromLocalStorage(MESSAGE_KEY),
          ApiType.ON_HOLD_RELEASE_CYCLE
        ).then((encryptedContentData) => {
          let requestData;
          if (fileBase64Encoding !== null && fileBase64Encoding !== "") {
            requestData = {
              requestId: generateRequestId(),
              loginId: getFromLocalStorage(LOGIN_ID),
              sessionId: getFromLocalStorage(SESSION_ID),
              contentData: encryptedContentData,
              loginUserName: getFromLocalStorage(USER_NAME),
              fileContent: fileBase64Encoding,
            };
          } else {
            requestData = {
              requestId: generateRequestId(),
              loginId: getFromLocalStorage(LOGIN_ID),
              sessionId: getFromLocalStorage(SESSION_ID),
              contentData: encryptedContentData,
              loginUserName: getFromLocalStorage(USER_NAME),
            };
          }

          fetchDataFileUpload(
            process.env.REACT_APP_RELEASE_ON_HOLD_TRANSACTION_TYPE_API_URL,
            ApiType.ON_HOLD_RELEASE_CYCLE,
            ApiType.POST_METHOD,
            requestData,
            {},
            (data) => {
              if (data !== null) {
                if (data.responseCode === "0") {
                  navigate("/OnHoldActionItemsSuccess", {
                    state: { data: data.result, type: 0 },
                  });
                }
              }
            }
          );
        });
      } else {
        showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
      }
    } catch (error) {
      const message = error.response != null ? error.response : error.message;
      showErrorAlert(
        error.message,
        ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
      );
    }
  };

  const requestOnHoldCancel = (onHoldCancelRequestData, fileBase64Encoding) => {
    try {
      if (isNetworkConnectionAvailable) {
        initializeEncryption(
          onHoldCancelRequestData,
          getFromLocalStorage(MESSAGE_KEY),
          ApiType.ON_HOLD_CANCEL_CYCLE
        ).then((encryptedContentData) => {
          let requestData;
          if (fileBase64Encoding !== null && fileBase64Encoding !== "") {
            requestData = {
              requestId: generateRequestId(),
              loginId: getFromLocalStorage(LOGIN_ID),
              sessionId: getFromLocalStorage(SESSION_ID),
              contentData: encryptedContentData,
              loginUserName: getFromLocalStorage(USER_NAME),
              fileContent: fileBase64Encoding,
            };
          } else {
            requestData = {
              requestId: generateRequestId(),
              loginId: getFromLocalStorage(LOGIN_ID),
              sessionId: getFromLocalStorage(SESSION_ID),
              contentData: encryptedContentData,
              loginUserName: getFromLocalStorage(USER_NAME),
            };
          }

          fetchDataFileUpload(
            process.env.REACT_APP_CANCEL_ON_HOLD_TRANSACTION_TYPE_API_URL,
            ApiType.ON_HOLD_CANCEL_CYCLE,
            ApiType.POST_METHOD,
            requestData,
            {},
            (data) => {
              if (data !== null) {
                if (data.responseCode === "0") {
                  navigate("/OnHoldActionItemsSuccess", {
                    state: { data: data.result, type: 1 },
                  });
                }
              }
            }
          );
        });
      } else {
        showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
      }
    } catch (error) {
      const message = error.response != null ? error.response : error.message;
      showErrorAlert(
        error.message,
        ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
      );
    }
  };

 const rejectOnHoldApiRequest = (onHoldCancelRequestData, fileBase64Encoding) => {
    try {
      if (isNetworkConnectionAvailable) {
        initializeEncryption(
          onHoldCancelRequestData,
          getFromLocalStorage(MESSAGE_KEY),
          ApiType.REJECT_ON_HOLD_TRANSACTION_TYPE
        ).then((encryptedContentData) => {
          let requestData;
          if (fileBase64Encoding !== null && fileBase64Encoding !== "") {
            requestData = {
              requestId: generateRequestId(),
              loginId: getFromLocalStorage(LOGIN_ID),
              sessionId: getFromLocalStorage(SESSION_ID),
              contentData: encryptedContentData,
              loginUserName: getFromLocalStorage(USER_NAME),
              fileContent: fileBase64Encoding,
            };
          } else {
            requestData = {
              requestId: generateRequestId(),
              loginId: getFromLocalStorage(LOGIN_ID),
              sessionId: getFromLocalStorage(SESSION_ID),
              contentData: encryptedContentData,
              loginUserName: getFromLocalStorage(USER_NAME),
            };
          }

          fetchDataFileUpload(
            process.env.REACT_APP_REJECT_ON_HOLD_TRANSACTION_TYPE_API_URL,
            ApiType.REJECT_ON_HOLD_TRANSACTION_TYPE,
            ApiType.POST_METHOD,
            requestData,
            {},
            (data) => {
              if (data !== null) {
                if (data.responseCode === "0") {
                  navigate("/OnHoldActionItemsSuccess", {
                    state: { data: data.result, type: 3 },
                  });
                }
              }
            }
          );
        });
      } else {
        showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
      }
    } catch (error) {
      const message = error.response != null ? error.response : error.message;
      showErrorAlert(
        error.message,
        ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
      );
    }
  };
  const requestReleaseOnHoldApiCall = (
    onHoldCancelRequestData,
    fileBase64Encoding
  ) => {
    try {
      if (isNetworkConnectionAvailable) {
        initializeEncryption(
          onHoldCancelRequestData,
          getFromLocalStorage(MESSAGE_KEY),
          ApiType.ON_HOLD_REQUEST_RELEASE_CYCLE
        ).then((encryptedContentData) => {
          let requestData;
          if (fileBase64Encoding !== null && fileBase64Encoding !== "") {
            requestData = {
              requestId: generateRequestId(),
              loginId: getFromLocalStorage(LOGIN_ID),
              sessionId: getFromLocalStorage(SESSION_ID),
              contentData: encryptedContentData,
              loginUserName: getFromLocalStorage(USER_NAME),
              fileContent: fileBase64Encoding,
            };
          } else {
            requestData = {
              requestId: generateRequestId(),
              loginId: getFromLocalStorage(LOGIN_ID),
              sessionId: getFromLocalStorage(SESSION_ID),
              contentData: encryptedContentData,
              loginUserName: getFromLocalStorage(USER_NAME),
            };
          }

          fetchDataFileUpload(
            process.env
              .REACT_APP_REQUEST_RELEASE_ON_HOLD_TRANSACTION_TYPE_API_URL,
            ApiType.ON_HOLD_REQUEST_RELEASE_CYCLE,
            ApiType.POST_METHOD,
            requestData,
            {},
            (data) => {
              if (data !== null) {
                if (data.responseCode === "0") {
                  navigate("/OnHoldActionItemsSuccess", {
                    state: { data: data.result, type: 2 },
                  });
                }
              }
            }
          );
        });
      } else {
        showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
      }
    } catch (error) {
      const message = error.response != null ? error.response : error.message;
      showErrorAlert(
        error.message,
        ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
      );
    }
  };

  async function getOnHoldDealer(
    companyCode,
    holdType,
    receivedBatchNo,
    commissionType,
    transactionType,
    pageNo,
    pageSize,
    selectedFilter,
    searchQuery
  ) {
    try {
      if (isNetworkConnectionAvailable) {
        const requestObject = createRequestObject(
          holdType,
          companyCode,
          receivedBatchNo,
          pageNo,
          pageSize,
          selectedFilter,
          searchQuery
        );

        initializeEncryption(
          requestObject,
          getFromLocalStorage(MESSAGE_KEY),
          ApiType.GET_PAYOUT_SUMMARY_TRANSACTION_TYPE
        ).then((encryptedContentData) => {
          fetchData(
            process.env.REACT_APP_ON_HOLD_PAYOUT_SUMMARY_TRANS_TYPE_API_URL,
            ApiType.GET_PAYOUT_SUMMARY_TRANSACTION_TYPE,
            ApiType.POST_METHOD,
            encryptedContentData,
            {},
            (data) => {
              if (data !== null) {
                const responseData = data.result.content.map((row) => ({
                  ...row,
                  id: generateRandomId(),
                }));
                setOnHoldSummary(responseData);
                setRowsPerPage(data.result.content.length);
                setTotalNoOfRows(data.result.totalElements);
                setTotalNoOfPages(data.result.totalPages);
              }

              checkSelectedOnHoldTransactionType();
              
          
              getHeaderSummary(
                holdType,
                selectedOnHoldTransactionType?.batchNo,
                companyCode,
                transactionType
              );
            }
          );
        });
      } else {
        showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
      }
    } catch (error) {
      const message = error.response != null ? error.response : error.message;
      showErrorAlert(
        error.message,
        ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
      );
    }
  }

  // Create Request Object for API call for table data
  function createRequestObject(holdType, companyCode, batchNo, pageNumber, pageSize, selectedFilter, filterValue) {
    let requestObject = {
      holdType: holdType,
      companyCode: companyCode,
      batchNo: batchNo,
      pageNumber: pageNumber,
      pageSize: pageSize,
    };

    // Set the appropriate field based on filterCriteria
    if (selectedFilter != null && selectedFilter != undefined && selectedFilter != "" && selectedFilter.paramName != "") {
      if (filterValue != null && filterValue != undefined && filterValue != "") {
        requestObject[selectedFilter] = filterValue;
      }
    }

    // sorting
    try{
      if (sortModel.length > 0) {
        // set sortProperty according to the field
        switch (sortModel[0].field) {
          case "transactionType":
            requestObject.sortProperty = "TRANSACTION_TYPE";
            break;
          case "reportDate":
            requestObject.sortProperty = "REPORT_DATE";
            break;
          case "cutOffDate":
            requestObject.sortProperty = "CUT_OFF";
            break;
          case "payOutDate":
            requestObject.sortProperty = "PAYOUT_BY";
            break;
          default:
            break;
        }

        // set the sort order
        requestObject.sortOrder = sortModel[0].sort.toString().toUpperCase();
      } 
    } catch (error) {
      DebugLog("Error in sorting: " + error);
      requestObject.sortProperty = null;
      requestObject.sortOrder = null;
    }

    return requestObject;
  }

  function blockNavigation(location, action) {
    // Block navigation if action is "pop", which indicates back/forward button press
    if (action === "pop") {
      // Optionally, you can show a message to the user before blocking navigation
      alert("Back button is disabled.");
      return false;
    }
    return true; // Allow navigation for other actions like "push" or "replace"
  }

  // search & filter handler
  const handleSearch = (filterParam, searchQuery) => {
    setSelectedFilter(filterParam);
    setSearchQuery(searchQuery);

    setPaginationModel({ pageSize: pageSize, page: 0 });

    checkSelectedOnHoldTransactionType();

    getOnHoldDealer(
      selectedOnHoldTransactionType?.companyCode,
      selectedOnHoldTransactionType?.holdType,
      selectedOnHoldTransactionType?.batchNo,
      selectedOnHoldTransactionType?.commissionType,
      selectedOnHoldTransactionType?.transactionType,
      0,
      paginationModel.pageSize,
      filterParam,
      searchQuery
    );
  }

  // handle error code reusable block
  function handleError(error) {
    setLoading(false);

    if (error.message === NO_INTERNET_CONNECTION_FOUND) {
      // Handle no internet connection error
      showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
      return;
    }

    const errorCode = error.data?.errorCode;
    var errorMessage =
      error.response != null ? error.displayErrorMessage : "Unknown";
    if (error.data?.displayErrorMessage) {
      errorMessage = error.data.displayErrorMessage;
    }

    const errorActions = {
      [ApiErrorCode.SESSION_EXPIRED]: () => navigate(CONSTANT.LOGIN),
      [ApiErrorCode.SESSION_ID_NOT_FOUND]: () => navigate("/"),
      [ApiErrorCode.UNABLE_TO_PROCESS_ERROR]: () =>
        navigate(CONSTANT.FINANCE_DASHBOARD),
      default: () =>
        showErrorAlert(
          error.message,
          ERROR_WHILE_FETCHING_DATA + JSON.stringify(errorMessage)
        ),
    };

    (errorActions[errorCode] || errorActions.default)();
  }

  function showErrorAlert(title, content) {
    try {
      DebugLog("an error found====" + content);
      setError();
      setLoading(false);

      setTitle(title);
      setContent(content);
      setErrorDialog(true);
    } catch (error) {
      DebugLog(error);
    }
  }

  const showNoInternetSnackBar = () => {
    if (isNetworkConnectionAvailable) {
      enqueueSnackbar(YOU_ARE_ONLINE);
    } else {
      enqueueSnackbar(YOU_ARE_OFFLINE, {
        autoHideDuration: 3000,
        variant: "error",
      });
    }
  };

  /***** Navigation *******/
  const handleRowClick = (params) => {
    checkSelectedOnHoldTransactionType();
    navigate(CONSTANT.ON_HOLD_ALL_TRANSACTIONS_DETAILS, {
      state: {
        holdType: selectedOnHoldTransactionType.holdType,
        companyCode: selectedOnHoldTransactionType.companyCode,
        batchNo: params.row.batchNo,
        commissionType: params.row.commissionType,
        transactionType: params.row.transactionType,
        displayName: params.row.transactionType,
      },
    });
  };

  /***** Navigation *******/
  const handleBackClicked = () => {
    checkSelectedOnHoldTransactionType();

    if (
      selectedOnHoldTransactionType.rootStartPageSelectedColumn ===
      "dealerCount"
    ) {
      navigate(CONSTANT.ON_HOLD_PAYOUT_CYCLE_ROUTE);
    } else {
      navigate(CONSTANT.PAYOUT_DEALER_SUMMARY_ROUTE);
    }
  };

  return (
    /* Main Container */
    <Box>
      <SnackbarProvider maxSnack={3}>
        <ConnectionStatus />
        <DownloadPayoutOnHoldReportNameSelectionDialog
          open={downloadFileDialogOpen}
          handleClose={handleFileDownloadDialogClose}
          handleSubmit={handleFileDownloadSubmit}
          batchNo={batchNo}
          type={clickedButtonType}
          title={dialogTitle}
          reportNameOption={reportNameOptions}
          reportNamesList={reportNamesValue}
        />
        <ShowErrorAlertDialog
          status={getDialogStatus}
          title={title}
          content={content}
        />
        {isNetworkConnectionAvailable ? (
          <CustomProgressDialog open={loading} text={getProgressbarText} />
        ) : (
          showNoInternetSnackBar()
        )}
        <Grid
          container
          component="main"
          direction={"column"}
          sx={{
            // height: "100vh",
            m: "0 2.5%" /* Approx 30px */,
            borderRadius: "18px",
          }}
        >
          {/* Header */}
          <Grid container direction={"row"} alignItems={"center"} mb={2} ml={2}>
            <Grid item mr={2}>
              <IconButton onClick={handleBackClicked} width={12}>
                <img src={"../../assets/common/Back.svg"} width={12} />
              </IconButton>
            </Grid>
            <Grid item>
              <Typography
                color={colors.grey[100]}
                fontWeight={"600"}
                variant="h3"
              >
                {transactionType}
              </Typography>
            </Grid>
          </Grid>
          {/* Header */}
          {/* Highlight Stats */}
          <HighlightStats
            highlightTotal={
              "RM " + formatPrice(onHoldHeaderSummary.totalAmount)
            }
            highlight1={"Device Reimbursement"}
            highlight1Stat={
              "RM " + formatPrice(onHoldHeaderSummary.deviceAmount)
            }
            highlight2={"Incentives"}
            highlight2Stat={
              "RM " + formatPrice(onHoldHeaderSummary.incentiveAmount)
            }
          ></HighlightStats>
          {/* Highlight Stats */}

          {/* On Hold Section */}
          <Grid
            container
            mt={3}
            border={"1px solid" + colors.grey[600]}
            borderRadius={3}
            xs={12}
            sm={12}
            md={12}
            lg={12}
            xl={12}
            pb={2}
          >
            <SectionHeader
              sectionIcon={
                <svg
                  width="36"
                  height="36"
                  viewBox="0 0 36 36"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15.975 28.665V7.335C15.975 5.31 15.12 4.5 12.96 4.5H7.515C5.355 4.5 4.5 5.31 4.5 7.335V28.665C4.5 30.69 5.355 31.5 7.515 31.5H12.96C15.12 31.5 15.975 30.69 15.975 28.665Z"
                    stroke="#292D32"
                    stroke-width="2.25"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M31.4987 28.665V7.335C31.4987 5.31 30.6437 4.5 28.4837 4.5H23.0387C20.8937 4.5 20.0237 5.31 20.0237 7.335V28.665C20.0237 30.69 20.8787 31.5 23.0387 31.5H28.4837C30.6437 31.5 31.4987 30.69 31.4987 28.665Z"
                    stroke="#292D32"
                    stroke-width="2.25"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              }
              sectionHeading={"Transaction Type"}
              isSearchBarEnabled={true}
              filterProps={filterProps}
              onSearch={handleSearch}
            ></SectionHeader>

            {onHoldSummary.length > 0 ? (
              <Box
                borderRadius={3}
                flex={1}
                m="0px 0 0 0"
                pb={0}
                height={gridHeight}
                sx={{
                  "& .MuiDataGrid-root": {
                    border: "none",
                  },
                  "& .MuiDataGrid-cell": {
                    borderBottom: "none",
                  },
                  "& .name-column--cell": {
                    color: colors.redAccent[200],
                    fontWeight: "bold",
                    fontSize: 13,
                  },
                  "& .MuiDataGrid-columnHeaders": {
                    backgroundColor: "rgba(255,255,255,0.6)",
                    borderBottom: "none",
                    fontWeight: "bold",
                    fontSize: "13px",
                    color: `${colors.grey[300]} !important`,
                  },
                  "& .MuiDataGrid-virtualScroller": {
                    background: "rgba(255,255,255,1)",
                  },
                  "& .MuiDataGrid-footerContainer": {
                    borderTop: "none",
                    backgroundColor: "rgba(255,255,255,0.6)",
                  },
                  "& .MuiCheckbox-root": {
                    //color: `${colors.white[200]} !important`,
                  },
                  "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
                    color: `${colors.grey[300]} !important`,
                    // backgroundColor: "rgba(255,255,255,0.6)",
                    // opacity:.5
                  },
                }}
              >
                <DataGrid
                  classes={{ row: "dataGridRow" }}
                  rows={onHoldSummary}
                  columns={onHoldCompanyColumnHeader}
                  checkboxSelection
                  selectionModel={selectedRows}
                  onSelectionModelChange={handleSelectionChange}
                  pageSize={pageSize}
                  rowCount={totalNoOfRows}
                  paginationModel={paginationModel}
                  paginationMode="server"
                  keepNonExistentRowsSelected
                  disableSelectionOnClick // Disable row selection on row click
                  onPageChange={handlePageChange}
                  onPageSizeChange={handlePageSizeChange}
                  rowsPerPageOptions={[15, 30, 45, 60]}
                  autoHeight
                  onRowClick={handleRowClick}

                  sortModel={sortModel}
                  onSortModelChange={(newSortModel) => setSortModel(newSortModel)}
                />
              </Box>
            ) : (
              NoDataFound()
            )}
          </Grid>

          {onHoldSummary.length > 0 ? (
            <Box item mt={6}>
              <Typography>
                <span>Jump to page: </span>
                <select
                  value={paginationModel.page + 1}
                  onChange={handlePageJump}
                >
                  {[...Array(totalNoOfPages)].map((_, index) => (
                    <option key={index} value={index + 1}>
                      {index + 1}
                    </option>
                  ))}
                </select>
              </Typography>
            </Box>
          ) : (
            ""
          )}

          {/* On Hold Section */}
          {/* Confirmation Dialog */}
          <IncentivesActionsConfirmationDialog
            open={dialogOpen}
            handleClose={handleDialogClose}
            handleSubmit={handleSubmit}
            type={clickedButtonType}
            title={dialogTitle}
          />
          {/* Confirmation Dialog */}

          {/* Action Buttons */}

          {onHoldSummary.length > 0 ? (
            <Grid item mt={1} justifyContent={"flex-start"} pb={10}>
              <Stack direction="row" spacing={2} justifyContent={"flex-end"}>
                {requestReleaseButtonVisible && actionButtonVisibility ? (
                  <CustomButton
                    btnBG={colors.grey[900]}
                    btnColor={colors.grey[100]}
                    // btnStartIcon={
                    //   <img src="../../assets/common/Cross.svg" width={22} />
                    // }
                    btnTxt={"Request Release"}
                    onClick={() => handleDialogOpen("Request Release")}
                  ></CustomButton>
                ) : (
                  ""
                )}
                {cancelButtonButtonVisibility && actionButtonVisibility ? (
                  <CustomButton
                    btnBG={colors.grey[900]}
                    btnColor={colors.grey[100]}
                    btnStartIcon={
                      <img src="../../assets/common/Cross.svg" width={22} />
                    }
                    btnTxt={"Cancel"}
                    onClick={() => handleDialogOpen("Cancel")}
                  ></CustomButton>
                ) : (
                  ""
                )}
                {rejectButtonVisibility && actionButtonVisibility ? (
                  <CustomButton
                    btnBG={colors.grey[900]}
                    btnColor={colors.grey[100]}
                    btnStartIcon={
                      <img src="../../assets/common/Tick.svg" width={22} />
                    }
                    btnTxt={"Reject"}
                    onClick={() => handleDialogOpen("Reject")}
                  ></CustomButton>
                ) : (
                  ""
                )}
                {releaseButtonVisibility && actionButtonVisibility ? (
                  <CustomButton
                    btnBG={colors.grey[900]}
                    btnColor={colors.grey[100]}
                    btnStartIcon={
                      <img src="../../assets/common/Tick.svg" width={22} />
                    }
                    btnTxt={"Release"}
                    onClick={() => handleDialogOpen("Release")}
                  ></CustomButton>
                ) : (
                  ""
                )}

                {/* {downloadButtonVisible ? (
                <DownloadDropdownButton
                  onFileTypeSelected={downloadOnHoldDetails}
                />
              ) : (
                ""
              )} */}
                {downloadButtonVisible ? (
                  <CustomButton
                    btnBG={colors.grey[900]}
                    btnColor={colors.grey[100]}
                    btnStartIcon={
                      <img src="../../assets/common/Download.svg" width={22} />
                    }
                    btnTxt={"Download"}
                    onClick={() => getReportName("Download")}
                  ></CustomButton>
                ) : (
                  ""
                )}
              </Stack>
            </Grid>
          ) : (
            ""
          )}
          {/* Action Buttons */}
        </Grid>
      </SnackbarProvider>
    </Box>
    /* Main Container */
  );
}
